export default __webpack_public_path__ + "static/media/xxusd-logo-ellipse-transparent-260x260.6e2c29da.svg";